import CityPageTemplate from "../city-template/CityPageTemplate";
import { loneTreeConfig } from "./data";

export default function LoneTreePage() {
  return <CityPageTemplate config={loneTreeConfig} />;
}